/**
 * Returns translated string based on locale
 * @param {string} defaultText - Default non-translated string
 * @param {object} translatedText - Hash of translated strings, key is locale
 * @param {string} locale - Locale code, i.e. es-ES for Spanish
 * @returns {string}
 */
export const getTranslatedText = (defaultText, translatedText, locale) => {
  if (translatedText && locale && Object.hasOwn(translatedText, locale)) {
    if (translatedText[locale].length > 0) {
      return translatedText[locale];
    }
    return defaultText;
  }
  return defaultText;
};
